import { defineStore } from "pinia";
import apiClient from "@/core/buildRequest";
import { useGeneralStore } from "@/store/General";
import snapchatIcon from "@/assets/images/icons/snapcaht.svg";
import xIcon from "@/assets/images/icons/x.svg";
import instagramIcon from "@/assets/images/icons/instagram.svg";
import facebookIcon from "@/assets/images/icons/facebook.svg";
import tiktokIcon from "@/assets/images/icons/tiktok.svg";
import phoneIcon from "@/assets/images/icons/phone.svg";
import LinkedInIcon from "@/assets/images/icons/linkedIn.svg";

export const useEditTaskStore = defineStore("useEditTaskStore", {
  state: () => ({
    title: "",
    status: { title: "To Do", color: "rgba(83, 100, 113, 1)" },
    tags: [],
    priority: "",
    description: "",
    time_estimate: "",
    from: null,
    to: null,
    assignees: [],
    add_to_social_media: 0,
    caption: "",
    type: "",
    platforms: [],
    branches: [],
    budget: "",
    budget_type: "",
    duration: "",
    users: [],
    status_list: [
      { title: "To Do", key: "todo", color: "rgba(83, 100, 113, 1)" },
      { title: "In Progress", key: "progress", color: "rgba(0, 133, 255, 1)" },
      { title: "Completed", key: "completed", color: "rgba(0, 186, 52, 1)" },
    ],
    priority_list: [
      { title: "urgent", color: "rgba(233, 44, 44, 1)" },
      { title: "high", color: "rgba(229, 160, 0, 1)" },
      { title: "normal", color: "rgba(0, 133, 255, 1)" },
      { title: "low", color: "rgba(83, 100, 113, 1)" },
      { title: "clear", color: "rgba(102, 102, 102, 1)" },
    ],
    branches_list: [],
    platforms_list: [],
    sponsor_end_date: null,
    setEndDate: false,
    attachments: [],
    comments: [],
    general_store: useGeneralStore(),
    errors: {},
    last_attachment: [],
    last_comments: [],
    Current_task_id: null,
  }),

  actions: {
    async getUsers() {
      try {
        const response = await apiClient.get("/leads-managment/all-agents");
        this.users = response.data.data;
      } catch (e) {
        console.error(e);
      }
    },

    updateStatus(status) {
      this.status = status;
    },

    formatDateTime(date) {
      if (!date) return null;
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(d.getDate()).padStart(2, "0")} ${String(
        d.getHours()
      ).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}:${String(
        d.getSeconds()
      ).padStart(2, "0")}`;
    },

    async getATask(id) {
      this.last_attachment = [];
      this.last_comments = [];
      this.comments = [];
      try {
        this.Current_task_id = id;
        const res = await apiClient.get(`/calender/tasks/${id}`);
        const task = res.data.data;

        console.log(task, "task");
        this.title = task.title;
        this.status = this.status_list.find((s) => s.key === task.status);
        this.tags = task.tags;
        this.from = new Date(task.time.start);
        this.to = new Date(task.time.end);
        this.priority = this.priority_list.find(
          (s) => s.title === task.priority
        );
        this.assignees = task.assignes.map((a) => a.id);
        this.description = task.description;
        this.time_estimate = task.time_estimate;
        this.add_to_social_media = task.add_to_social_media;

        if (task.social) {
          this.caption = task.social.caption || "";
          this.type = task.social.type || "organic";

          this.platforms = this.platforms_list
            .filter((p) => task.social.platforms?.includes(p.name))
            .map((p) => ({ ...p }));

          this.budget = task.social.budget || "";
          this.budget_type = task.social.budget_type || "";
          this.duration = task.social.duration || "";
          this.sponsor_end_date = task.social.end_date
            ? new Date(task.social.end_date)
            : null;
          this.setEndDate = !!this.sponsor_end_date;

          // نحتفظ بال branches names الجاية من ال API مؤقتًا
          this._loaded_branches = task.social.branches || [];
        } else {
          this.caption = "";
          this.type = "organic";
          this.platforms = [];
          this.budget = "";
          this.budget_type = "";
          this.duration = "";
          this.sponsor_end_date = null;
          this.setEndDate = false;
          this._loaded_branches = [];
        }

        this.last_attachment = task.attachments;
        this.last_comments = task.comments;
      } catch (e) {
        console.error(e);
      }
    },

    async getBranches(platforms) {
      try {
        const response = await apiClient.get("/all-platfroms-pages", {
          params: { platforms: platforms },
        });

        // تجهيز الـ branches_list بشكل طبيعي
        this.branches_list = response.data.data.map((b) => ({
          id: b.id,
          name: b.name,
          image: b.picture,
        }));

        // تحديد صورة البوست من آخر المرفقات اللي عندك
        const postImage = this.last_attachment.length
          ? this.last_attachment[0].path
          : null;

        // فلترة الـ branches بناءً على الـ task المحمل مسبقًا، وإضافة صورة البوست
        this.branches = this.branches_list
          .filter((b) => this._loaded_branches?.includes(b.name))
          .map((b) => ({
            ...b,
            postImage: postImage,
          }));
        console.log(this.branches, "branches");
      } catch (e) {
        console.error(e);
      }
    },
    async getPlatforms() {
      try {
        const response = await apiClient.get("/integration/all/integrations");
        this.platforms_list = response.data.data.map((p) => ({
          id: p.id,
          name: p.platform,
          key: p.platform,
          icon: p.icon,
          color:
            p.name === "facebook"
              ? "#1877F2"
              : p.name === "instagram"
              ? "#E4405F"
              : p.name === "tiktok"
              ? "#000000"
              : p.name === "twitter"
              ? "#1DA1F2"
              : p.name === "youtube"
              ? "#FF0000"
              : "#757575",
        }));
      } catch (e) {
        console.error(e);
      }
    },
    async SendTask() {
      try {
        const formData = new FormData();

        formData.append("title", this.title);
        formData.append("status", this.status.key);
        formData.append("priority", this.priority.title);
        formData.append("description", this.description);
        formData.append("time_estimate", this.time_estimate);
        formData.append("from", this.formatDateTime(this.from));
        formData.append("to", this.formatDateTime(this.to));
        formData.append("add_to_social_media", this.add_to_social_media);
        formData.append("caption", this.caption);
        formData.append("type", this.type);
        formData.append("budget", this.budget);
        formData.append("budget_type", this.budget_type);
        formData.append("duration", this.duration);
        formData.append(
          "sponsor_end_date",
          this.formatDateTime(this.sponsor_end_date)
        );
        formData.append("setEndDate", this.setEndDate);

        (this.tags || []).forEach((tag, index) => {
          formData.append(`tags[${index}]`, tag);
        });

        (this.platforms || []).forEach((platform, index) => {
          formData.append(`platforms[${index}]`, platform.name);
        });

        (this.branches || []).forEach((branch, index) => {
          formData.append(`branches[${index}]`, branch.name);
        });

        (this.assignees || []).forEach((assignee, index) => {
          formData.append(`assignees[${index}]`, assignee);
        });

        (this.attachments || []).forEach((attachment, index) => {
          formData.append(`attachment[${index}]`, attachment);
        });

        await apiClient.post(
          `/calender/tasks/${this.Current_task_id}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        this.general_store?.showSnackbar("Task has been sent" , "#237276");

      } catch (error) {
        console.error("Error sending task:", error);
        this.general_store?.showSnackbar("Error Sending Data", "error");
      }
    },
    async loadFullTask(id) {
      
      await this.getPlatforms();
      await this.getATask(id);
      await this.getBranches(this.platforms.map((p) => p.name));

      // هنا نربط صورة الـ post بعد تحميل كل حاجة
      const postImage = this.last_attachment.length
        ? this.last_attachment[0].path
        : null;

      this.branches = this.branches.map((b) => ({
        ...b,
        postImage: postImage,
      }));
    },

  },
});
